import i18n from '@/i18n';

export const deliveryItems: any = {
  'No sample shipment': {
    notes: [
      i18n.t('education.delivery.no_sample.note1', {
        defaultValue:
          'Please ensure your content is uploaded and the final link submitted on AhaCreator within <b>7 days of brand confirmation</b>'
      }),
      i18n.t('education.delivery.no_sample.note2', {
        defaultValue:
          'To help us track performance and secure your earnings, please make sure to include the promotional link in your content as specified in the CTA requirements'
      })
    ]
  },
  'With sample shipment': {
    notes: [
      i18n.t('education.delivery.with_sample.note1', {
        defaultValue:
          'Please ensure your content is uploaded and the final link submitted on AhaCreator within <b>7 days of product arrival</b>'
      }),
      i18n.t('education.delivery.with_sample.note2', {
        defaultValue:
          'To help us track performance and secure your earnings, please make sure to include the promotional link in your content as specified in the CTA requirements'
      })
    ]
  },
  'Dedicated video': {
    img: '/delivery-youtube1-education.png',
    notes: [
      i18n.t('education.delivery.dedicated_video.note1', {
        defaultValue:
          'To ensure your creative work is properly compensated, please begin production <b>only after the collaboration has been officially confirmed by the brand</b>.'
      }),
      i18n.t('education.delivery.dedicated_video.note2', {
        defaultValue:
          'If the brand requires a script submission, it must be submitted and approved <b>before proceeding to video production</b>. For other platforms, script is not required.'
      }),
      i18n.t('education.delivery.dedicated_video.note3', {
        defaultValue:
          'During the review process, the brand may request <b>up to four rounds of revisions</b>. For each revision request, creators will have <b>up to 7 days</b> to submit the updated content.'
      }),
      i18n.t('education.delivery.dedicated_video.note4', {
        defaultValue:
          'Any additional brand-specific requirements will be listed in the <b>"Requirement" section</b>. Please review them before starting your content production.'
      })
    ]
  },
  'Integrated video': {
    img: '/delivery-youtube2-education.png',
    notes: [
      i18n.t('education.delivery.integrated_video.note1', {
        defaultValue:
          'To ensure your creative work is properly compensated, please begin production <b>only after the collaboration has been officially confirmed by the brand</b>.'
      }),
      i18n.t('education.delivery.integrated_video.note2', {
        defaultValue:
          'If the brand requires a script submission, it must be submitted and approved <b>before proceeding to video production</b>.'
      }),
      i18n.t('education.delivery.integrated_video.note3', {
        defaultValue:
          'During the review process, the brand may request <b>up to four rounds of revisions</b>. For each revision request, creators will have <b>up to 5 days</b> to submit the updated content.'
      }),
      i18n.t('education.delivery.integrated_video.note4', {
        defaultValue:
          'Any additional brand-specific requirements will be listed in the <b>"Requirement" section</b>. Please review them before starting your content production.'
      })
    ]
  },
  tiktok: {
    img: 'https://website-resource.ahaglobal.io/ads-platform/ads-guide-other.png',
    verticalImgUrl:
      'https://website-resource.ahaglobal.io/ads-platform/ads-guide-other-mobile.png',
    notes: [
      i18n.t('education.delivery.tiktok.note1', {
        defaultValue:
          'To ensure your creative work is properly compensated, please begin production <b>only after the collaboration has been officially confirmed by the brand</b>.'
      }),
      i18n.t('education.delivery.tiktok.note2', {
        defaultValue:
          'If the brand requires a script submission, it must be submitted and approved <b>before proceeding to video production</b>.'
      }),
      i18n.t('education.delivery.tiktok.note3', {
        defaultValue:
          'During the review process, the brand may request <b>up to four rounds of revisions</b>. For each revision request, creators will have <b>up to 5 days</b> to submit the updated content.'
      }),
      i18n.t('education.delivery.tiktok.note4', {
        defaultValue:
          'Any additional brand-specific requirements will be listed in the <b>"Requirement" section</b>. Please review them before starting your content production.'
      })
    ]
  },
  twitter: {
    img: 'https://website-resource.ahaglobal.io/ads-platform/ads-guide-other.png',
    verticalImgUrl:
      'https://website-resource.ahaglobal.io/ads-platform/ads-guide-other-mobile.png',
    notes: [
      i18n.t('education.delivery.twitter.note1', {
        defaultValue:
          'To ensure your creative work is properly compensated, please begin production <b>only after the collaboration has been officially confirmed by the brand</b>.'
      }),
      i18n.t('education.delivery.twitter.note2', {
        defaultValue:
          'If the brand requires a script submission, it must be submitted and approved <b>before proceeding to video production</b>.'
      }),
      i18n.t('education.delivery.twitter.note3', {
        defaultValue:
          'During the review process, the brand may request <b>up to four rounds of revisions</b>. For each revision request, creators will have <b>up to 5 days</b> to submit the updated content.'
      }),
      i18n.t('education.delivery.twitter.note4', {
        defaultValue:
          'Any additional brand-specific requirements will be listed in the <b>"Requirement" section</b>. Please review them before starting your content production.'
      })
    ]
  },
  instagram: {
    img: 'https://website-resource.ahaglobal.io/ads-platform/ads-guide-other.png',
    verticalImgUrl:
      'https://website-resource.ahaglobal.io/ads-platform/ads-guide-other-mobile.png',
    notes: [
      i18n.t('education.delivery.instagram.note1', {
        defaultValue:
          'To ensure your creative work is properly compensated, please begin production <b>only after the collaboration has been officially confirmed by the brand</b>.'
      }),
      i18n.t('education.delivery.instagram.note2', {
        defaultValue:
          'If the brand requires a script submission, it must be submitted and approved <b>before proceeding to video production</b>.'
      }),
      i18n.t('education.delivery.instagram.note3', {
        defaultValue:
          'During the review process, the brand may request <b>up to four rounds of revisions</b>. For each revision request, creators will have <b>up to 5 days</b> to submit the updated content.'
      }),
      i18n.t('education.delivery.instagram.note4', {
        defaultValue:
          'Any additional brand-specific requirements will be listed in the <b>"Requirement" section</b>. Please review them before starting your content production.'
      })
    ]
  },
  linkedin: {
    img: 'https://website-resource.ahaglobal.io/ads-platform/ads-guide-other.png',
    verticalImgUrl:
      'https://website-resource.ahaglobal.io/ads-platform/ads-guide-other-mobile.png',
    notes: [
      i18n.t('education.delivery.linkedin.note1', {
        defaultValue:
          'To ensure your creative work is properly compensated, please begin production <b>only after the collaboration has been officially confirmed by the brand</b>.'
      }),
      i18n.t('education.delivery.linkedin.note2', {
        defaultValue:
          'If the brand requires a script submission, it must be submitted and approved <b>before proceeding to video production</b>.'
      }),
      i18n.t('education.delivery.linkedin.note3', {
        defaultValue:
          'During the review process, the brand may request <b>up to four rounds of revisions</b>. For each revision request, creators will have <b>up to 5 days</b> to submit the updated content.'
      }),
      i18n.t('education.delivery.linkedin.note4', {
        defaultValue:
          'Any additional brand-specific requirements will be listed in the <b>"Requirement" section</b>. Please review them before starting your content production.'
      })
    ]
  }
};

export const ctaItems: any = {
  youtube: {
    img: '/cta-youtube.png',
    notes: [
      i18n.t('education.cta.youtube.note1', {
        defaultValue:
          '<b>Engaging Video Placement:</b> Place the CTA at the most engaging point in your video to capture viewer interest effectively'
      }),
      i18n.t('education.cta.youtube.note2', {
        defaultValue:
          '<b>Description:</b> Use a strong call-to-action for promotion at the beginning of description. Ensure CTA and link are visible even when collapsed. '
      }),
      i18n.t('education.cta.youtube.note3', {
        defaultValue:
          '<b>Pinned Comment:</b> Post the CTA and promotional link as the first pinned comment to ensure it remains visible and accessible.'
      }),
      i18n.t('education.cta.youtube.note4', {
        defaultValue:
          '<b>AhaCreator-Provided Link:</b> Use the promotional link provided by AhaCreator, not the official website link or a redirected link.'
      }),
      i18n.t('education.cta.youtube.note5', {
        defaultValue:
          '<b>10 days display:</b> Please make sure to place the promotional link as required within 10 days of publishing. Otherwise, the advertiser may request a refund.'
      })
    ]
  },
  tiktok: {
    img: '/cta-tiktok.png',
    notes: [
      i18n.t('education.cta.tiktok.note1', {
        defaultValue: `<b>Ending CTA:</b> Prompt viewers in speech and with caption at the end of the video. E.g., "Tap the link in bio for more info!" `
      }),
      i18n.t('education.cta.tiktok.note2', {
        defaultValue: `<b>Caption:</b> Use a concise and engaging caption with a strong call-to-action. E.g., : "Check the link in bio now! 🌟"`
      }),
      i18n.t('education.cta.tiktok.note3', {
        defaultValue: `<b>Link in bio:</b> The link should be placed at the top of bio. If you're using Linktree, position your promotional link directly above Linktree or add it as the first link within Linktree to ensure it's easily accessible.`
      }),
      i18n.t('education.cta.tiktok.note4', {
        defaultValue: `<b>AhaCreator-Provided Link:</b> Use the promotional link provided by AhaCreator, not the official website link or a redirected link.`
      }),
      i18n.t('education.cta.tiktok.note5', {
        defaultValue:
          '<b>10 days display:</b> Please make sure to place the promotional link as required within 10 days of publishing. Otherwise, the advertiser may request a refund.'
      })
    ]
  },
  twitter: {
    img: '/cta-twitter.png',
    notes: [
      i18n.t('education.cta.twitter.note1', {
        defaultValue: `<b>Ending CTA:</b> If you are posting a video, prompt viewers in speech and with caption at the end of the video. E.g., "Visit the link in our tweet for more info!" `
      }),
      i18n.t('education.cta.twitter.note2', {
        defaultValue: `<b>Caption:</b> Post with a strong CTA in the caption, like: "Check out more: {link}🌟"`
      }),
      i18n.t('education.cta.twitter.note3', {
        defaultValue: `<b>AhaCreator-Provided Link:</b> Use the promotional link provided by AhaCreator, not the official website link or a redirected link.`
      }),
      i18n.t('education.cta.twitter.note4', {
        defaultValue:
          '<b>10 days display:</b> Please make sure to place the promotional link as required within 10 days of publishing. Otherwise, the advertiser may request a refund.'
      })
    ]
  },
  instagram: {
    img: '/cta-instagram.png',
    notes: [
      i18n.t('education.cta.instagram.note1', {
        defaultValue: `<b>Ending CTA:</b> If you are posting a Reel, clearly state, "Check the link in bio!" depending on the features available.`
      }),
      i18n.t('education.cta.instagram.note2', {
        defaultValue: `<b>Caption:</b> Use a concise and engaging caption with a strong call-to-action. E.g., : "Check the link in bio now! 🌟"`
      }),
      i18n.t('education.cta.instagram.note3', {
        defaultValue: `<b>Link in bio:</b> The link should be placed at the top of bio. If you're using Linktree, position your promotional link directly above Linktree or add it as the first link within Linktree to ensure it's easily accessible.`
      }),
      i18n.t('education.cta.instagram.note4', {
        defaultValue: `<b>AhaCreator-Provided Link:</b> Use the promotional link provided by AhaCreator, not the official website link or a redirected link.`
      }),
      i18n.t('education.cta.instagram.note5', {
        defaultValue:
          '<b>10 days display:</b> Please make sure to place the promotional link as required within 10 days of publishing. Otherwise, the advertiser may request a refund.'
      })
    ]
  },
  linkedin: {
    img: '/cta-linkedin.png',
    notes: [
      i18n.t('education.cta.linkedin.note1', {
        defaultValue: `<b>Ending CTA:</b> If you are posting with a video, integrate a clear verbal or text-based CTA within the video, such as "Visit the link in my post for more info."`
      }),
      i18n.t('education.cta.linkedin.note2', {
        defaultValue: `<b>Caption:</b> Post with a strong CTA in the caption, like: "Check out more: {link}🌟"`
      }),
      i18n.t('education.cta.linkedin.note3', {
        defaultValue: `<b>AhaCreator-Provided Link:</b> Use the promotional link provided by AhaCreator, not the official website link or a redirected link.`
      }),
      i18n.t('education.cta.linkedin.note4', {
        defaultValue:
          '<b>10 days display:</b> Please make sure to place the promotional link as required within 10 days of publishing. Otherwise, the advertiser may request a refund.'
      })
    ]
  }
};

export const policyItems: any = [
  {
    title: i18n.t('education.policy.organic_views.title', {
      defaultValue: '100% organic views '
    }),
    des: i18n.t('education.policy.organic_views.desc', {
      defaultValue:
        'Content should generate organic and authentic views. If fraudulent activity is detected, the brand may request a refund.'
    })
  },
  {
    title: i18n.t('education.policy.off_platform.title', {
      defaultValue: 'No off-platform transactions'
    }),
    des: i18n.t('education.policy.off_platform.desc', {
      defaultValue:
        'For collaborations sourced through AhaCreator, all communications and transactions with brands must remain on the platform to ensure secure payments.'
    })
  },
  {
    title: i18n.t('education.policy.late_submission.title', {
      defaultValue: 'Timely delievery'
    }),
    des: i18n.t('education.policy.late_submission.desc', {
      defaultValue:
        'Please submit content according to the agreed timeline. Both late kickoffs and delayed submissions (beyond 2 days after kickoff) may affect eligibility for extra bonuses. In severe cases, brands may choose to cancel the collaboration.'
    })
  },
  {
    title: i18n.t('education.policy.quality.title', {
      defaultValue: 'Content quality'
    }),
    des: i18n.t('education.policy.quality.desc', {
      defaultValue:
        'Content should provide value to your audience. Fully AI-generated content is not permitted.'
    })
  },
  {
    title: i18n.t('education.policy.cancellation.title', {
      defaultValue: 'Deal cancellation'
    }),
    des: i18n.t('education.policy.cancellation.desc', {
      defaultValue:
        'If a deal is cancelled for personal reasons, creators may be responsible for covering any direct losses incurred by the brand (e.g., product or shipping costs).'
    })
  },
  {
    title: i18n.t('education.policy.agreement.title', {
      defaultValue: 'Creator Agreement'
    }),
    des: i18n.t('education.policy.agreement.desc', {
      defaultValue:
        'Please review the Creator Agreement carefully to understand your rights and responsibilities on the platform. '
    })
  }
];

export const items = [
  i18n.t('education.tabs.delivery', { defaultValue: 'Delivery timeline' }),
  i18n.t('education.tabs.cta', { defaultValue: 'CTA requirements' }),
  i18n.t('education.tabs.policy', { defaultValue: 'Platform policy' }),
  i18n.t('education.tabs.payment', { defaultValue: 'Payment' })
];

export const trendDeliveryItems: any = {
  imgUrl:
    'https://website-resource.ahaglobal.io/ads-platform/ads-guide-trend.png',
  verticalImgUrl:
    'https://website-resource.ahaglobal.io/ads-platform/ads-guide-trend.png-vertical',
  notes: [
    "To ensure your creative work is properly compensated, <span class='text-text-color-primary text-base font-bold font-['Inter'] leading-7'> please do not start production</span> until the collaboration is confirmed by the brand.",
    'During the review process, the brand may request <b>up to four rounds of revisions</b>. For each revision request, creators will have <b>up to 1 days</b> to submit the updated content.'
  ]
};
